/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TrustCommercesubscriptionsSubscription model module.
 * @module model/TrustCommercesubscriptionsSubscription
 * @version v0.3
 */
export default class TrustCommercesubscriptionsSubscription {
  /**
   * Constructs a new <code>TrustCommercesubscriptionsSubscription</code>.
   * @alias module:model/TrustCommercesubscriptionsSubscription
   * @class
   * @param subscriptionPlanId {String} ID of the subscription plan this subscription is for
   * @param billingId {String} The ID of the billing that will be made into a subscription
   */
  constructor(subscriptionPlanId, billingId) {
    this.subscriptionPlanId = subscriptionPlanId;
    this.billingId = billingId;
  }

  /**
   * Constructs a <code>TrustCommercesubscriptionsSubscription</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrustCommercesubscriptionsSubscription} obj Optional instance to populate.
   * @return {module:model/TrustCommercesubscriptionsSubscription} The populated <code>TrustCommercesubscriptionsSubscription</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TrustCommercesubscriptionsSubscription();
      if (data.hasOwnProperty('subscription_plan_id'))
        obj.subscriptionPlanId = ApiClient.convertToType(data['subscription_plan_id'], 'String');
      if (data.hasOwnProperty('billing_id'))
        obj.billingId = ApiClient.convertToType(data['billing_id'], 'String');
    }
    return obj;
  }
}

/**
 * ID of the subscription plan this subscription is for
 * @member {String} subscriptionPlanId
 */
TrustCommercesubscriptionsSubscription.prototype.subscriptionPlanId = undefined;

/**
 * The ID of the billing that will be made into a subscription
 * @member {String} billingId
 */
TrustCommercesubscriptionsSubscription.prototype.billingId = undefined;

